export const CONTACT = {
    name: "Unimicron Technology India",
    shortName: "Unimicron",
    address:
        "H-60, Durga Industrial Area, Sahibabad, Ghaziabad, Uttar Pradesh, India",
    email: "sales@unimicronind.com",
    phone1: "+91 9621235273",
    phone1Href: "tel:+919621235273",
    phone2: "+91 8178381904",
    phone2Href: "tel:+918178381904",
    hours: "Monday - Saturday, 9:30 AM - 6:30 PM IST",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1557701197-2f99da0922dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxtYWNybyUyMHBjYiUyMGNpcmN1aXQlMjBib2FyZCUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzkxNzk3MTk0fDA&ixlib=rb-4.1.0&q=85&w=1920&auto=format&fit=crop",
    about: "https://images.unsplash.com/photo-1526392269816-39d8ed656494?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxwcmludGVkJTIwY2lyY3VpdCUyMGJvYXJkJTIwY2xvc2V1cCUyMGdyZWVufGVufDB8fHx8MTc5MTc5NzI5M3ww&ixlib=rb-4.1.0&q=85&w=1200&auto=format&fit=crop",
    manufacturing: "https://images.unsplash.com/photo-1593687395549-400945fed803?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxtYWNybyUyMHBjYiUyMGNpcmN1aXQlMjBib2FyZCUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzkxNzk3MTk0fDA&ixlib=rb-4.1.0&q=85&w=1400&auto=format&fit=crop",
    infra1: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZWxlY3Ryb25pY3MlMjBmYWN0b3J5JTIwcm9ib3RpY3N8ZW58MHx8fHwxNzkxNzk3MTk0fDA&ixlib=rb-4.1.0&q=85&w=1400&auto=format&fit=crop",
    infra2: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwZWxlY3Ryb25pY3MlMjBmYWN0b3J5JTIwcm9ib3RpY3N8ZW58MHx8fHwxNzkxNzk3MTk0fDA&ixlib=rb-4.1.0&q=85&w=1400&auto=format&fit=crop",
    segments: "https://images.unsplash.com/photo-1662819202032-d3f07430724a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxlbGVjdHJvbmljJTIwcG93ZXIlMjBzdXBwbHklMjBjb21wb25lbnRzfGVufDB8fHx8MTc5MTc5NzE5NHww&ixlib=rb-4.1.0&q=85&w=1400&auto=format&fit=crop",
    quality: "https://images.unsplash.com/photo-1607398027609-fbd1a06fb5d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxlbGVjdHJvbmljcyUyMGZhY3RvcnklMjBwcm9kdWN0aW9uJTIwbGluZSUyMHdvcmtlcnN8ZW58MHx8fHwxNzkxNzk3MjkzfDA&ixlib=rb-4.1.0&q=85&w=1400&auto=format&fit=crop",
    pcbBoard: "https://images.unsplash.com/photo-1724770388447-30b015a5cbb6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxlbGVjdHJvbmljJTIwY2lyY3VpdCUyMGJvYXJkJTIwYXNzZW1ibHklMjBmYWN0b3J5JTIwZW5naW5lZXJ8ZW58MHx8fHwxNzkxODAwNjA2fDA&ixlib=rb-4.1.0&q=85&w=1400&auto=format&fit=crop",
    factoryDrill: "/images/factory-drill.jpg",
    factoryQuality: "/images/factory-quality.jpg",
    factoryTesting: "/images/factory-testing.jpg",
    factoryDispatch: "/images/factory-dispatch.jpg",
    prodDrilling: "/images/prod-drilling.jpg",
    prodPlating: "/images/prod-plating.jpg",
    prodMask: "/images/prod-mask.jpg",
    prodPanels: "/images/prod-panels.jpg",
};

export const SEGMENTS = [
    { id: "power-electronics", name: "Power Electronics", icon: "Zap", desc: "High-current boards for power conversion, drives and energy handling equipment." },
    { id: "ups-inverters", name: "UPS & Inverters", icon: "BatteryCharging", desc: "PCBs built for continuous duty in UPS systems, inverters and stabilizers." },
    { id: "power-supplies", name: "Power Supplies", icon: "PlugZap", desc: "SMPS, adapters and industrial power supply boards with reliable copper paths." },
    { id: "energy-meters", name: "Energy Meters", icon: "Gauge", desc: "Metering PCBs with clean layouts for accurate, long-life energy measurement." },
    { id: "iot-smart-devices", name: "IoT & Smart Devices", icon: "Cpu", desc: "Compact boards for connected devices, sensors and embedded controllers." },
    { id: "industrial-automation", name: "Industrial Automation", icon: "Factory", desc: "Boards for automation panels, PLC interfaces and machine control electronics." },
    { id: "control-systems", name: "Control Systems", icon: "Waypoints", desc: "Control and interface PCBs for process control and instrumentation equipment." },
    { id: "led-lighting", name: "LED & Lighting", icon: "Lightbulb", desc: "LED driver and lighting PCBs with efficient thermal and current distribution." },
    { id: "automotive-electronics", name: "Automotive Electronics", icon: "Car", desc: "Rugged boards for vehicle electronics, chargers and automotive accessories." },
    { id: "consumer-electronics", name: "Consumer Electronics", icon: "Smartphone", desc: "Cost-effective PCBs for appliances, chargers and everyday electronic products." },
    { id: "networking-telecom", name: "Networking & Telecom", icon: "RadioTower", desc: "Boards for networking hardware, telecom equipment and communication devices." },
    { id: "industrial-electronics", name: "Industrial Electronics", icon: "CircuitBoard", desc: "General industrial electronic PCBs built for durability and stable performance." },
];

export const PCB_TYPES = [
    {
        id: "single-layer",
        num: "01",
        name: "Single Layer PCB",
        tag: "SINGLE-SIDED",
        image: "/images/pcb-single.jpg",
        desc: "Single layer PCBs carry conductive copper traces on one side of the substrate, making them the most simple, economical and dependable board class for straightforward circuits. We manufacture single-sided boards for power, control and consumer applications where proven, low-cost reliability matters.",
        features: [
            "Copper-clad FR-4, phenolic and CEM substrates",
            "Economical for simple, high-volume circuits",
            "Ideal for power supplies, relays and LED boards",
            "Consistent solder masking and legend printing",
        ],
        specs: [
            { k: "Substrates", v: "FR-4, CEM-1, CEM-3, Phenolic" },
            { k: "Copper Weight", v: "1 – 3 oz" },
            { k: "Board Thickness", v: "0.8 – 2.0 mm" },
            { k: "Surface Finish", v: "HASL / Lead-free HASL" },
            { k: "Solder Mask", v: "Green, Red, Blue, Black, White" },
            { k: "Legend / Silkscreen", v: "White or Black epoxy ink" },
        ],
        applications: ["Power Supplies", "LED & Lighting", "Relay Modules", "Consumer Appliances"],
    },
    {
        id: "double-layer",
        num: "02",
        name: "Double Layer PCB",
        tag: "DOUBLE-SIDED",
        image: "/images/pcb-double.jpg",
        desc: "Double layer PCBs use both sides of the substrate with plated through holes connecting the layers, allowing denser and more complex routing. This class suits control boards, meters and industrial electronics that need more functionality in the same footprint.",
        features: [
            "Plated through holes for reliable layer interconnection",
            "Higher component density in the same board area",
            "Suitable for analog, digital and mixed circuits",
            "Optional HASL and finish routes as per requirement",
        ],
        specs: [
            { k: "Substrates", v: "FR-4, CEM-3" },
            { k: "Copper Weight", v: "1 – 3 oz" },
            { k: "Board Thickness", v: "0.8 – 2.4 mm" },
            { k: "Holes", v: "Plated through holes (PTH)" },
            { k: "Surface Finish", v: "HASL / Lead-free HASL" },
            { k: "Solder Mask", v: "Green, Red, Blue, Black, White" },
        ],
        applications: ["Energy Meters", "Control Systems", "Industrial Electronics", "Automotive Electronics"],
    },
    {
        id: "multilayer",
        num: "03",
        name: "Multilayer PCB",
        tag: "MULTI-LAYER",
        image: "/images/pcb-multilayer.jpg",
        desc: "Multilayer PCBs bond multiple copper layers together with insulating prepreg, delivering compact, high-performance boards for advanced electronics. We manufacture multilayer boards with controlled lamination and disciplined process control for demanding applications.",
        features: [
            "Multiple bonded copper layers with precise registration",
            "Internal power and ground planes for clean signal paths",
            "Compact footprints for advanced and dense designs",
            "Layer stack-up reviewed at the engineering stage",
        ],
        specs: [
            { k: "Layer Count", v: "4 – 8 layers (typical builds)" },
            { k: "Copper Weight", v: "1 – 2 oz (inner & outer)" },
            { k: "Board Thickness", v: "1.0 – 2.4 mm" },
            { k: "Dielectric", v: "FR-4 prepreg & core" },
            { k: "Planes", v: "Internal power / ground planes" },
            { k: "Stack-up", v: "Confirmed at DFM review" },
        ],
        applications: ["IoT & Smart Devices", "Networking & Telecom", "Industrial Automation", "Power Electronics"],
    },
    {
        id: "metal-core",
        num: "04",
        name: "Metal Core PCB",
        tag: "METAL CORE / MCPCB",
        image: "/images/pcb-metal.jpg",
        desc: "Metal core PCBs use an aluminium or metal base with a thermally conductive dielectric layer to pull heat away from components. This makes them the preferred choice for high-power LED lighting, power electronics and applications where thermal management is critical.",
        features: [
            "Metal base layer for effective heat dissipation",
            "Thermally conductive dielectric insulation",
            "High-current carrying capability",
            "Excellent mechanical rigidity and durability",
        ],
        specs: [
            { k: "Base Layer", v: "Aluminium, 1.0 – 3.0 mm" },
            { k: "Dielectric", v: "Thermally conductive, 1 – 2 W/m·K" },
            { k: "Copper Weight", v: "1 – 4 oz (high current)" },
            { k: "Construction", v: "Single-sided (double on review)" },
            { k: "Surface Finish", v: "HASL / Lead-free HASL" },
            { k: "Best Suited For", v: "High-power LED & power circuits" },
        ],
        applications: ["LED & Lighting", "Power Electronics", "UPS & Inverters", "Automotive Electronics"],
    },
];

export const SPEC_NOTE =
    "Typical manufacturing ranges for guidance. Your exact build is confirmed at the DFM review stage — send your Gerber data for confirmation.";

export const STACKUP_LAYERS = [
    { id: "mask-top", name: "Solder Mask — Top", color: "#166534", h: 7, desc: "Protective solder mask over the top copper pattern, with openings only at pads." },
    { id: "cu-top", name: "Top Copper", color: "#B45309", h: 10, desc: "Outer signal layer — traces, pads and component footprints etched from 1–2 oz copper foil." },
    { id: "pp-1", name: "Prepreg", color: "#D6C7A1", h: 14, desc: "Bonding layer that melts and cures during lamination, insulating copper layers from each other." },
    { id: "cu-in1", name: "Inner Copper — GND", color: "#92400E", h: 10, desc: "Internal ground plane providing clean return paths and shielding for signals." },
    { id: "core", name: "FR-4 Core", color: "#294531", h: 22, desc: "Rigid fibreglass-epoxy core — the structural backbone of the board." },
    { id: "cu-in2", name: "Inner Copper — PWR", color: "#92400E", h: 10, desc: "Internal power plane distributing clean supply rails across the board." },
    { id: "pp-2", name: "Prepreg", color: "#D6C7A1", h: 14, desc: "Second bonding layer, identical in function to the first." },
    { id: "cu-bot", name: "Bottom Copper", color: "#B45309", h: 10, desc: "Outer bottom layer for routing and solder-side assembly." },
    { id: "mask-bot", name: "Solder Mask — Bottom", color: "#166534", h: 7, desc: "Protective mask on the solder side, matched to the top for finish consistency." },
];

export const DFM_CHECKS = [
    "Gerber package completeness — all copper, mask and legend layers present",
    "Drill files, tool sizes and annular ring verification",
    "Trace and space clearances checked against process capability",
    "Board outline, slots and panelization review",
    "Copper balance and solder mask alignment checks",
    "Layer stack-up and build confirmation for multilayer orders",
];

export const FAQS = [
    {
        q: "What data do you need to quote my PCB?",
        a: "A complete Gerber package (RS-274X copper, mask and legend layers) along with drill files, ideally as a single ZIP. Also share the board thickness, copper weight and quantity. You can attach everything directly in the enquiry form.",
    },
    {
        q: "Is there a minimum order quantity?",
        a: "No strict MOQ. We manufacture from a few prototype boards up to regular production quantities, priced accordingly.",
    },
    {
        q: "How soon will I receive a quotation?",
        a: "Once we receive complete data, our team reviews it and typically responds with pricing and delivery details within 1–2 working days.",
    },
    {
        q: "Can you manufacture from a schematic or a sample board?",
        a: "Production requires manufacturing data (Gerber and drill files). If you only have a schematic or a layout file, share it with us — our team will guide you on generating the Gerber outputs from your design tool.",
    },
    {
        q: "Which surface finishes do you offer?",
        a: "HASL and lead-free HASL are standard. If your application needs a special finish, mention it in the enquiry and we will confirm feasibility.",
    },
    {
        q: "Can you handle urgent prototype orders?",
        a: "Yes. Share your data and quantity and we will confirm the earliest possible dispatch for your prototype.",
    },
    {
        q: "How do I send large Gerber files?",
        a: "Compress the files into a single ZIP or RAR and attach them to the enquiry form — up to 15 MB is accepted. For larger packages, share a download link in the message field.",
    },
    {
        q: "Do you deliver across India?",
        a: "Yes. Boards are carefully packed and dispatched to destinations across India, planned against the delivery date confirmed with you.",
    },
];

export const PROCESS_STEPS = [
    { num: "01", title: "Data Review & Engineering", desc: "Every Gerber package is reviewed for completeness and manufacturability before production begins." },
    { num: "02", title: "Imaging & Etching", desc: "Copper circuit patterns are precisely imaged and etched to customer design data." },
    { num: "03", title: "Lamination & Drilling", desc: "Layers are laminated and drilled with controlled registration for reliable interconnects." },
    { num: "04", title: "Plating & Finishing", desc: "Holes are plated through and surfaces finished as per the customer specification." },
    { num: "05", title: "Inspection & Testing", desc: "Boards pass visual inspection and electrical checks before they are approved for dispatch." },
    { num: "06", title: "Packing & Dispatch", desc: "Approved boards are carefully packed and dispatched on committed timelines." },
];

export const PILLARS = [
    { icon: "ShieldCheck", title: "Quality", desc: "Consistent, process-controlled PCB manufacturing with multi-stage inspection at every step." },
    { icon: "IndianRupee", title: "Competitive Pricing", desc: "Fair, transparent pricing for prototypes and production volumes alike." },
    { icon: "Headphones", title: "Reliable Service", desc: "Responsive, technical and dependable support from enquiry to delivery." },
    { icon: "Clock", title: "Timely Delivery", desc: "Committed dispatch schedules that keep your production lines running." },
];
